import React, { useEffect, useState } from 'react';
import Loader from '../../../../_common/Loader/Loader';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';

const DRUG_CONFIG = {
  Diabetes: { label: 'Diabetes medications (ADH-D)', color: '#3730A3' },
  Hypertension: { label: 'Hypertension / RAS antagonists (ADH-H)', color: '#F97316' },
  Cholesterol: { label: 'Cholesterol / statins (ADH-C)', color: '#EF4444' },
};

const FALLBACK_COLORS = ['#6366F1', '#22C55E', '#A78BFA', '#0EA5E9'];

const getStatusMessage = (rate) => {
  if (rate >= 88) return null;
  if (rate >= 80) return { text: 'Above 80% threshold - watch for decline', color: '#6B7280' };
  return { text: 'Below 80% threshold - intervention required', color: '#EF4444' };
};

const CmsStarRatings = ({ requestData }) => {
  const [cmsStarRatingsData, setCmsStarRatingsData] = useState([]);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getCmsStarRatings(requestData);

        setCmsStarRatingsData(data.data || []);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  const isEmpty = !cmsStarRatingsData.length;

  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    if (!loading && !isEmpty) {
      const id = requestAnimationFrame(() => setAnimated(true));
      return () => cancelAnimationFrame(id);
    }

    setAnimated(false);
  }, [loading, cmsStarRatingsData]);

  return (
    <div className={classes.chart_kpi_wrapper} style={{ padding: 16 }}>
      <p style={{
        margin: '0 0 4px', fontWeight: 700, fontSize: 15, color: '#111827',
      }}
      >
        CMS star ratings - adherence measures
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : isEmpty
          ? <div className={classes.chart_is_empty}>No data to display</div>

          : (
            <>
              <p style={{ margin: '0 0 20px', fontSize: 12, color: '#6B7280' }}>
                PDC-based · ≥80% = adherent · ≥88% targets 5 stars
              </p>

              {cmsStarRatingsData.map((row, idx) => {
                const cfg = DRUG_CONFIG[row.drugType];
                const label = cfg?.label ?? row.drugType;
                const color = cfg?.color ?? FALLBACK_COLORS[idx % FALLBACK_COLORS.length];
                const pct = row.adherenceRate ?? 0;
                const status = getStatusMessage(pct);

                return (
                  <div key={row.drugType} style={{ marginBottom: 16 }}>
                    <p style={{ margin: '0 0 6px', fontSize: 13, color: '#374151' }}>{label}</p>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <div style={{
                        flex: 1,
                        height: 20,
                        borderRadius: 4,
                        background: '#E5E7EB',
                        overflow: 'hidden',
                      }}
                      >
                        <div style={{
                          height: '100%',
                          borderRadius: 4,
                          background: color,
                          width: animated ? `${Math.max(pct, 0)}%` : '0%',
                          transition: `width 0.8s cubic-bezier(0.4, 0, 0.2, 1) ${idx * 0.15}s`,
                        }}
                        />
                      </div>

                      <span style={{
                        minWidth: 40,
                        textAlign: 'right',
                        fontWeight: 700,
                        fontSize: 14,
                        color,
                      }}
                      >
                        {`${pct}%`}
                      </span>
                    </div>

                    {status && (
                      <p style={{ margin: '4px 0 0', fontSize: 12, color: status.color }}>
                        {status.text}
                      </p>
                    )}
                  </div>
                );
              })}
            </>
          )}
    </div>
  );
};

export default CmsStarRatings;
